function qtyCount(){
  let qtyCountgrid = 0;
  let t_qtyCountgrid = 0
  $('.block-coll-list.active .pro-coll-grid [name="quantity"]').each(function name(params) {
    let eachQty = parseInt($(this).val());
    qtyCountgrid += eachQty;
  });
  $('.block-coll-list .pro-coll-grid [name="quantity"]').each(function name(params) {
    let t_eachQty = parseInt($(this).val());
    t_qtyCountgrid += t_eachQty;
  });
  $('.t_meal_total_count').text(t_qtyCountgrid)
  console.log(t_qtyCountgrid)
  let updateQty = 0
  $('.block-coll-list.active').each(function (e) {
    updateQty += $(this).data('count'); 
  });
  if(qtyCountgrid>=updateQty){
    var percentageCount = 100;
    $('.bundle_meal,.frequency_btn').removeClass('disabled');
  }else{
    var percentageCount = parseFloat(qtyCountgrid*100/updateQty);
    $('.bundle_meal,.frequency_btn').addClass('disabled');
  }
  $('.progressbar span').css("width", percentageCount+"%");
  $('.block-coll-list.active').each(function (e) {
    let thisColl = $(this);
    let collectionWiseQty = 0;
    var countSpecific = parseInt($(this).attr('data-count'));
    $(this).find('[name="quantity"]').each(function (e) {
      collectionWiseQty += parseInt($(this).val());
    });
    if(collectionWiseQty>=countSpecific){
      $(this).find('.add_temp_meal,.static_add').addClass('disabled');
    }else{
      $(this).find('.add_temp_meal,.static_add').removeClass('disabled');
    }
  });
  console.log(updateQty,qtyCountgrid)
  if(qtyCountgrid>=updateQty){
    var meal_update = updateQty
  }else{
    var meal_update = qtyCountgrid
  }
  $('.meal_update_count').text(meal_update);
  $('.meal_total_count').text(updateQty);
}
qtyCount();
$(document).on('click','.cleartbtn',function (e) {
  e.preventDefault();
  $('.pro-coll-grid').removeClass('active');
  $('.pro-coll-grid').removeClass('activeqty');
  $('.pro-coll-grid').find('[name="quantity"]').val(0);
  qtyCount();
  $('.pro-coll-grid').find('.gquantity_countinr').text(0);
  $('.pro-coll-grid').find('.gquantity_count').removeClass('active');
  //$('.sticky-coll-list.active').first().trigger('click');
  $('html, body').stop().animate({
      scrollTop: $('.block-coll-list.active').offset().top - $('.coll_meal_progress').height()
   }, 1000);
  $('.clear_tooptip').hide();
});
$(document).on('change','.single-option-selector',function(e) {
  e.preventDefault();
  let variant_val = $('.product-form__variants option:selected').attr('data-title');
  let option_Val = $(this).val();
  console.log(variant_val)
  $('.sticky-coll-list').each(function (e) {
    let coll_title = $(this).data('title');
    if(coll_title.indexOf('breakfast') !== -1){
      if(variant_val.indexOf('yes') !== -1){
        $(this).addClass('active')
      }else{
        $(this).removeClass('active');
      }
      /*if(option_Val == 'Yes'){
        $(this).addClass('active')
      }else{
        $(this).removeClass('active');
      }*/
    }
  });
  $('.block-coll-list').each(function(e){
    let coll_title = $(this).data('title');
    let coll_num = $(this).data('count');
    let removepreSelection = $(this).data('preselected');
    console.log(removepreSelection)
    if(coll_title.indexOf('breakfast') !== -1){
      if(variant_val.indexOf('yes') !== -1){
        if(removepreSelection == true){
          $(this).addClass('enable_breakfast');
          $(this).removeClass('disable_breakfast');
          $(this).find('.pro-coll-grid').addClass('active');
          $(this).addClass('active');
          $(this).find('[name="quantity"]').val(0);
          $(this).find('.gquantity_countinr').text(0);
          $(this).find('.gquantity_count').removeClass('active');
        }else{
          $(this).addClass('active');
          $(this).find('.pro-coll-grid').slice(0, coll_num).each(function(index, element) {
            $(element).find('[name="quantity"]').val(1);
            $(element).find('.gquantity_countinr').text(1);
            $(element).find('.gquantity_count').addClass('active');
          });
          $(this).addClass('enable_breakfast');
          $(this).removeClass('disable_breakfast');
          $(this).find('.pro-coll-grid').addClass('active');     
        }          
      }else{
        $(this).removeClass('active');
        $(this).find('[name="quantity"]').val(0);
        $(this).removeClass('enable_breakfast');
        $(this).addClass('disable_breakfast');
        $(this).find('.pro-coll-grid').removeClass('active');
        $(this).find('.gquantity_countinr').text(0);
        $(this).find('.gquantity_count').removeClass('active');
      }
    }
  });
  $('.pro-collvariant-list option').each(function (value,index) {
    var variant_option_title = $(this).attr('data-title');
    var var_Id = $(this).val();
    if (variant_val.indexOf(variant_option_title) !== -1) {
      $(this).attr('selected', 'selected').siblings().removeAttr('selected');
      $(this).closest('.pro-coll-grid').find('.pro-grid-variant[data-id="'+var_Id+'"]').addClass('active').siblings().removeClass('active');
    }
  });
  qtyCount();
});
$(document).on('change','.pro-collvariant-list',function(e) {
  var temp_var_Id = $(this).val();
  var temp_var_price = $(this).find('option:selected').data('price');
  var temp_var_compareprice = $(this).find('option:selected').data('compare');
  $(this).closest('.pro-coll-grid').find('.pro-grid-variant[data-id="'+temp_var_Id+'"]').addClass('active').siblings().removeClass('active');
  $(this).closest('.pro-coll-grid').find('.pro-coll-normal-price').text(temp_var_price);
  console.log(temp_var_compareprice)
  $(this).closest('.pro-coll-grid').find('.pro-coll-compare-price').text(temp_var_compareprice);
  if(temp_var_compareprice == ''){
    $(this).closest('.pro-coll-grid').find('.pro-coll-sale_label').addClass('hide');
  }else{
    $(this).closest('.pro-coll-grid').find('.pro-coll-sale_label').removeClass('hide');
  }
    
});
/*$('#selling-plan-selection-all').change(function() {
  let globalText = $(this).find('option:selected').text();
  let currentVal = $(this).val();
  let lowercaseGlobal = globalText.toLowerCase().replace(/\s+/g, ' ').trim();
  $('.cart-selling-plan-selection option').each( function(index) {
    let eachSubscribe = $(this).text();
    let eachSubscribeLowercase = eachSubscribe.toLowerCase().replace(/\s+/g, ' ').trim();
    if(lowercaseGlobal.indexOf(eachSubscribeLowercase) !== -1){
       $(this).prop('selected', true);     
    }
  });
});*/
$('.frq_radio').change(function() {
  let globalText = $(this).text();
  let currentVal = $(this).val();
  let lowercaseGlobal = currentVal.toLowerCase().replace(/\s+/g, ' ').trim();
  console.log(lowercaseGlobal)
  $('.cart-selling-plan-selection option').each( function(index) {
    let eachSubscribe = $(this).text();
    let eachSubscribeLowercase = eachSubscribe.toLowerCase().replace(/\s+/g, ' ').trim();
    if(lowercaseGlobal.indexOf(eachSubscribeLowercase) !== -1){
       $(this).prop('selected', true);     
    }
  });
});
$('.onetimepurchase').on('click',function(e){
  $('[name="frequency_plan"]').removeAttr('checked');
  $('.cart-selling-plan-selection #selling_plan_onetime').prop('selected', true);
});
$(document).on('click','.bundle_meal',function (e) {
  //e.preventDefault();
  let items = [];
  const this_btn = $(this);
  const form = $('.pro-coll-wrap');
  const customProperty = form.find('input[name="custom_property"]').val();
  form.find('.pro-coll-grid.active').each(function() {
      const variantId = $(this).find('select[name="gridvariant_id"]').val();
      const sellingId = $(this).find('.cart-selling-plan-selection').val();
      const quantity = $(this).find('input[name="quantity"]').val();
      items.push({ 
          id: variantId, 
          quantity: parseInt(quantity),
          properties: {
              'Part of': customProperty
          },
          selling_plan:sellingId
      });
  });
   $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ items: items }),
       beforeSend: function() {
          // Add class before sending the request
          $(this_btn).addClass('before-success');
      },
      success: function(data) {
        //console.log(data)
        $(this_btn).removeClass('before-success');
        window.location.href = '/cart';
      },
      error: function(error) {
        console.error('Error adding products to cart:', error);
      }
  });
});
/*$('.meal-plus').click(function() {
  var $quantity = $(this).siblings('.quantity');
  var currentVal = parseInt($quantity.val());
  if (!isNaN(currentVal)) {
      $quantity.val(currentVal + 1);
  }
});*/
$('.meal-minus').click(function() {
  var $quantity = $(this).siblings('[name="quantity"]');
  var currentVal = parseInt($quantity.val());
  if (!isNaN(currentVal) && currentVal > 0) {
    $quantity.val(currentVal - 1);
    $(this).closest('.pro-coll-grid').find('.gquantity_countinr').text(currentVal-1);
    let newVal = currentVal - 1;
    if(newVal==0){
      $(this).closest('.pro-coll-grid').find('.gquantity_count').removeClass('active');
      $(this).closest('.pro-coll-grid').removeClass('active');
      $(this).closest('.pro-coll-grid').removeClass('activeqty');
    }else{
      $(this).closest('.pro-coll-grid').find('.gquantity_count').addClass('active');
      $(this).closest('.pro-coll-grid').addClass('active');
    }
     qtyCount();
  }
});
$(document).on('click','.add_temp_meal',function (e) {
  e.preventDefault();
  $(this).closest('.pro-coll-grid').addClass('active');
  let qty_current = parseInt($(this).closest('.pro-coll-grid').find('[name="quantity"]').val());
  qty_current++;
  $(this).closest('.pro-coll-grid').find('[name="quantity"]').val(qty_current);
  $(this).closest('.pro-coll-grid').find('.gquantity_countinr').text(qty_current);
  $(this).closest('.pro-coll-grid').find('.gquantity_count').addClass('active');
  qtyCount();
});
$(document).on('click','.delete_temp_meal',function (e) {
  e.preventDefault();
  $(this).closest('.pro-coll-grid').removeClass('active');
  $(this).closest('.pro-coll-grid').find('[name="quantity"]').val(0);
  $(this).closest('.pro-coll-grid').find('.gquantity_countinr').text(0);
  $(this).closest('.pro-coll-grid').find('.gquantity_count').removeClass('active');
  qtyCount();
});
$(document).on('click','.static_add',function (e) {
  e.preventDefault();
  $(this).closest('.pro-coll-grid').addClass('activeqty');
  var currentdatQty = $(this).closest('.pro-coll-grid').find('[name="quantity"]').val();
  if(currentdatQty == 0){
    $(this).closest('.pro-coll-grid').find('.add_temp_meal').trigger('click');
  }
});
var $targetSection = $('.pro-coll-wrap');
$(window).on('scroll', function() {
    if ($targetSection.length === 0) {
        //console.warn("Target section not found in the DOM.");
        return; // Exit the function early
    }
    var sectionTop = $targetSection.offset().top;
    var sectionBottom = sectionTop + $targetSection.outerHeight() + $('.plus-accordion').outerHeight() + $('#judgeme_product_reviews').outerHeight();
    var scrollPosition = $(window).scrollTop();
    var windowHeight = $(window).height();
    var viewBottom = scrollPosition + windowHeight;
    // Check if the target section is in the viewport
    if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        $targetSection.addClass('highlight');
    } else {
        $targetSection.removeClass('highlight');
    }
});
$(document).on('click','.sticky-coll-list',function (e) {
  $(this).addClass('selected').parent('li').siblings().find('.sticky-coll-list').removeClass('selected');
  var stickyHeight = $('.coll_meal_progress').height() + 100;
  var target = $(this.getAttribute('href'));
  var scrollPosition = $(window).scrollTop();
  var offsetTop = $('.main-collmeal-wrap').offset().top;
  if (target.length) {
     event.preventDefault();
     $('html, body').stop().animate({
        scrollTop: target.offset().top - stickyHeight
     }, 1000);
  }
  $('.pro-coll-wrap').removeClass('active');
})
$('.pdp-more-info a').click(function(e) {
  e.preventDefault();
  $('#pdp-popup').addClass('active');
  $('body').addClass('opn-pdpd');
});
$('#pdp-closePopup').click(function(e) {
  e.preventDefault();
  $('#pdp-popup').removeClass('active');
  $('body').removeClass('opn-pdpd');
});
$(window).click(function(event) {
  if ($(event.target).is('#pdp-popup')) {
    $('#pdp-popup').removeClass('active');
    $('body').removeClass('opn-pdpd');
  }
});
function scollNext() {
 $('.block-coll-list.active').each(function (e) {
   let collQtyCount = $(this).data('count');
   var griddQtyCount = 0;
   let collHanle = $(this).next('.block-coll-list').data('title');
   $(this).find('[name="quantity"]').each(function (e) {
     griddQtyCount += parseInt($(this).val());
   });
   if(griddQtyCount>=collQtyCount){
     $('.sticky-coll-list[data-title="'+collHanle+'"]').trigger('click');
   }
 });
}
$(document).on('click','.tab-burger',function (e) {
  e.preventDefault();
  $('.pro-coll-wrap').toggleClass('active');
});
$('.quick-view-button').on('click', function(event) {
  event.preventDefault();
  const productHandle = $(this).data('product-handle');
  $.get(`/products/${productHandle}?section_id=meal-quick-view`, function(response) {
    const quickViewContent = $(response).find('.quick-view-content').html();
    $('#quick-view-modal .mealmodal-contentinr').html(quickViewContent);
    $('#quick-view-modal').addClass('open');
  });
});
$('.mealmodal-close').on('click', function() {
  $('#quick-view-modal').removeClass('open');
});
$(document).on('click', function(event) {
  if ($(event.target).closest('.mealmodal-content').length === 0 && $(event.target).closest('.quick-view-button').length === 0) {
    $('#quick-view-modal').removeClass('open');
  }
});
$('.frequency_btn').on('click', function(event) {
  event.preventDefault();
  $('#freq-modal').addClass('open');
});
$('.freqmodal-close').on('click', function() {
  $('#freq-modal').removeClass('open');
});
$(document).on('click', function(event) {
  if ($(event.target).closest('.frq_modal-content').length === 0 && $(event.target).closest('.frequency_btn').length === 0) {
    $('#freq-modal').removeClass('open');
  }
});
$(document).on('click','.back_freq',function(e){
  $('.frq_modal').removeClass('second_fre_step');
});
$(document).on('click','.next_freq',function(e){
  $('.frq_modal').addClass('second_fre_step');
});
$(document).on('click','.close_clear_tip',function(e){
  e.preventDefault();
  $('.clear_tooptip').hide();
});